/**
 * Base class for typed option categories (e.g., FrequencyType).
 * Holds a human-readable name identifying the option type.
 * Subclasses extend this to add domain-specific properties
 * (e.g., maxNumberOfRecurrences, getEndDate logic).
 */
class OptionType {
  name: string;

  constructor(name: string) {
    this.name = name;
  }

  getName(): string {
    return this.name;
  }
}

export default OptionType;
